import { useEffect, useState, useRef } from "react";
import { createPortal } from "react-dom";
import { getSearchAPI } from "@/redux/Purchase/actions";
import { useDispatch } from "react-redux";
import "./SearchBar.css";
import { useDebounced } from "@/hooks/useDebounced";

export const SearchBar = ({
  selectReacord,
  searchAPI,
  value,
  inputStyle = "",
  minword = 2,
  showResults = 1,
  onchange = () => { },
  paramCompanyId = "CompanyId",
}) => {
  const [input, setInput] = useState(value);
  const [searchResult, setSearchResult] = useState([]);
  // console.log("searchResult: ", searchResult);
  const [dropdownPos, setDropdownPos] = useState(null);
  // console.log("dropdownPos: ", dropdownPos);
  const dispatch = useDispatch();
  const wrapperRef = useRef(null);
  const [MasterCompanyDetails] = JSON.parse(
    localStorage.getItem("MasterCompanyDetails") ?? "[{}]",
  );

  useEffect(() => {
    setInput(value);
  }, [value]);
  const updatePosition = () => {
    if (!wrapperRef.current) return;

    const rect = wrapperRef.current.getBoundingClientRect();

    setDropdownPos({
      top: rect.bottom + window.scrollY,
      left: rect.left + window.scrollX,
      width: rect.width,
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", updatePosition, true);
    window.addEventListener("resize", updatePosition);

    return () => {
      window.removeEventListener("scroll", updatePosition, true);
      window.removeEventListener("resize", updatePosition);
    };
  }, []);

  useEffect(() => {
    if (searchResult.length) updatePosition();
  }, [searchResult]);
  const handleClickOutside = (event) => {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
      setSearchResult([]);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const fetchData = async (value) => {
    if (!value) {
      setSearchResult([]);
      return;
    }
    const URL =
      searchAPI +
      value +
      `&${paramCompanyId}=${MasterCompanyDetails?.CompanyId}`;
    // console.log("URL", URL);
    const sdata = await dispatch(getSearchAPI(URL));
    const result = sdata.map((obj) => Object.values(obj));
    setSearchResult(result);
  };

  const fetch = useDebounced(fetchData, 300);

  const handleChange = (value) => {
    setInput(value);
    onchange(value);
    if (value?.length > minword) {
      fetch(value);
    } else {
      setSearchResult([]);
    }
  };

  const dropdown =
    searchResult.length > 0 && dropdownPos ? (
      <div
        style={{
          position: "absolute",
          top: dropdownPos.top + 2,
          left: dropdownPos.left,
          width: dropdownPos.width,
          zIndex: 99999,
        }}
        className="border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 max-h-[150px] overflow-y-auto shadow-lg pointer-events-auto"
      >
        {searchResult.map((result, id) => (
          <div
            key={id}
            className="cursor-pointer py-1 px-2 text-[14px] hover:bg-slate-100 dark:hover:bg-slate-700"
            onMouseDown={(e) => e.stopPropagation()}
            onClick={(e) => {
              selectReacord(result);
              setInput(result?.[1]);
              setSearchResult([]);
              handleClickOutside(e);
            }}
          >
            {result[showResults]}
          </div>
        ))}
      </div>
    ) : null;

  return (
    <>
      <div className="relative" ref={wrapperRef}>
        <input
          placeholder="Type to search..."
          value={input}
          onChange={(e) => handleChange(e.target.value)}
          className={
            "w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-1 focus:ring-[#0072FF] focus:border-[#0072FF] " +
            inputStyle
          }
        />
      </div>

      {dropdown && createPortal(dropdown, document.body)}
    </>
  );
};
